export enum serviceOrderPriorityEnum {
    HIGH = 'ALTA',
    MEDIUN = 'MEDIA',
    LOW = 'BAIXA',
}

